import { hsl } from 'polished';
export default {
    global: {
        black: '#000',
        white: '#fff',
        beige: '#E6E6DC',
    },
    blue: {
        default: '#0086FF',
        light: '#E3F2FF',
        medium: '#C3E2FF',
        dark: '#003D74',
        navy: '#002240',
        gradient: `linear-gradient(var(--direction, 180deg), #0662B5 var(--start, 0%), #0086FF var(--end, 100%))`,
    },
    green: {
        default: '#2FB457',
        light: '#D5F0DD',
        medium: '#A9DEB8',
        dark: '#288639',
        lightGradient: `linear-gradient(var(--direction, 180deg), #D5F0DD var(--start, 0%), #8ED5A3 var(--end, 100%))`,
        gradient: `linear-gradient(var(--direction, 180deg), #2FB457 var(--start, 0%), #1F833D var(--end, 100%))`,
    },
    validation: {
        /** Hex: #28a745 */
        valid: '#28a745',
        /** Hex: #dc3545 */
        invalid: '#dc3545',
    },
    grey: {
        background: '#F8F8F8',
        light: '#D9D9D9',
        dark: '#5E6163',
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
};
